import React, { Fragment } from 'react';
import { Card, Col, DatePicker, Form, InputNumber, Row, Select } from 'antd';
import { formatCurrency, parserNumber } from '../../../../utils';
import { GENDER } from '../../../../utils/const';

const { Option } = Select;

export default (props) => {

	const { getFieldDecorator } = props.form;

	return (
		<Fragment>
			<Card title="Thông tin bổ sung" className={'mt-20'}>
				<Row gutter={12}>
					<Col sm={12}>
						<Form.Item label={'Ngày sinh'}>
							{getFieldDecorator('dob', {})(
								<DatePicker
									style={{ width: '100%' }}
									format="YYYY-MM-DD"
									allowClear
									placeholder={'Chọn ngày sinh'}
								/>
							)}
						</Form.Item>
					</Col>
					<Col sm={12}>
						<Form.Item label={'Giới tính'}>
							{getFieldDecorator('gender', { initialValue: '0' })(
								<Select>
									{GENDER.map(el => <Option key={el.value}>{el.name}</Option>)}
								</Select>)}
						</Form.Item>
					</Col>
					<Col sm={12}>
						<Form.Item
							label={'Công nợ'}>
							{getFieldDecorator('totalDebt', {
								initialValue: 0
							})(
								<InputNumber style={{ width: '100%' }} formatter={formatCurrency}
														 parser={parserNumber} min={0} />
							)}

						</Form.Item>
					</Col>
					{/*<Col sm={12}>*/}
					{/*	<Form.Item*/}
					{/*		label={'Tổng chi tiêu'}>*/}
					{/*		{getFieldDecorator('totalAmount', {*/}
					{/*			initialValue: 0*/}
					{/*		})(*/}
					{/*			<InputNumber style={{ width: '100%' }} formatter={formatCurrency}*/}
					{/*									 parser={parserNumber} min={0} />*/}
					{/*		)}*/}

					{/*	</Form.Item>*/}
					{/*</Col>*/}
				</Row>
			</Card>
		</Fragment>
	);
};
